import { useState } from 'react'
import { cover } from '../../utility/constant/helper.constant'
import { TLedSpots, TLedSpotsSet } from '../../utility/type/terraceCover.type'

/**
 * Values and methods are used by the context API
 * @returns states being used to manipulate the scene
 */

export const useStateLedSpots = () => {
  const [ledSpots, setLedSpots] = useState<TLedSpots>(
    cover.terraceCover.ledSpots
  )

  const [ledSet, setLedSet] = useState<TLedSpotsSet>(
    cover.terraceCover.ledSpotsSet
  )

  const onHandleLedSpots = (value: TLedSpots) => {
    setLedSpots(value)
  }

  const onHandleLedSpotsSet = (value: TLedSpotsSet) => {
    setLedSet(value)
  }

  return {
    ledSpots: {
      type: ledSpots,
      quantity: ledSet,
    },

    ledSpotsMethod: {
      onHandleLedSpots,
      onHandleLedSpotsSet,
    },
  }
}
